export const GET_INDUSTRIES_WATCHER = 'GET_INDUSTRIES_WATCHER';
export const GET_INDUSTRIES_SUCCESS = 'GET_INDUSTRIES_SUCCESS';
export const GET_INDUSTRIES_FAILED = 'GET_INDUSTRIES_FAILED';
